import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, timer } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';

/** Maximum number of retries for transient errors (network failure or 5xx). */
const MAX_RETRIES = 3;

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      retry({
        count: MAX_RETRIES,
        delay: (error, retryIndex) => {
          // Only retry transient errors: network error (status 0) or server errors (5xx)
          if (error instanceof HttpErrorResponse && (error.status === 0 || error.status >= 500)) {
            const delayMs = Math.pow(2, retryIndex - 1) * 1000;
            console.debug(`[ErrorInterceptor] Retrying request (${retryIndex}/${MAX_RETRIES}) in ${delayMs}ms`, req.url);
            return timer(delayMs);
          }
          // Do not retry for other errors
          throw error;
        }
      }),
      catchError((err: HttpErrorResponse) => {
        if (err.status === 400 && err.error && err.error.errors) {
          // Map ValidationProblem to a consistent shape
          const fieldErrors = err.error.errors; // { field: [messages] }
          const mapped = { type: 'validation', fieldErrors };
          return throwError(() => ({ status: 400, validation: mapped }));
        }
        if (err.status === 0) {
          return throwError(() => ({
            status: 0,
            message: 'Erro de conexão. Verifique sua internet.'
          }));
        }
        if (err.status >= 500) {
          return throwError(() => ({
            status: err.status,
            message: 'Erro do servidor. Tente novamente mais tarde.'
          }));
        }
        return throwError(() => err);
      })
    );
  }
}
